import React, { ReactElement } from "react";
import styled from "styled-components";
import Text from "components/Text";
import { TextType } from "lib/design-system/typography";
import CenteredLoader from "components/CenteredLoader";

const Container = styled.div`
  width: 100%;
  height: 100vh;
`;

const LoaderContainer = styled.div`
  justify-content: center;
  align-items: center;
`;

const ErrorContainer = styled.div`
  margin: 40px;
  justify-content: flex-start;
  align-items: flex-start;
`;

interface Props {
  error: string | null;
  isLoading: boolean;
  children: ReactElement;
}

/**
 * A wrapper to help handle loading and error state and then render component when ready
 * Pass error and isLoading in as props and children in as the child component
 */
export const ComponentLoader = ({
  error,
  isLoading,
  children,
}: Props): ReactElement => {
  if (error) {
    return (
      <Container>
        <ErrorContainer>
          <Text type={TextType.ERROR_MESSAGE}>{`Error: ${error}`}</Text>
        </ErrorContainer>
      </Container>
    );
  }

  if (!children || isLoading) {
    return (
      <Container>
        <LoaderContainer>
          <CenteredLoader />
        </LoaderContainer>
      </Container>
    );
  }

  return <>{children}</>;
};

export default ComponentLoader;
